import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import Listing from "../../lessons/Listing";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchAntweight } from "../../../redux/action/weightAction";

const Antweights = () => {
  const dispatch = useDispatch();
  const { antweightsList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );
 
  useEffect(() => {
    dispatch(fetchAntweight());
  }, []);


  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Antweights"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Antweights",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={antweightsList} />

        <Footer />
      </div>
    </>
  );
};

export default Antweights;
